module.exports = __webpack_public_path__ + "static/img/m_name.73038b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/swbnzk/m_name.png
// module id = VZj5
// module chunks = 7